import React from 'react'
import cn from 'classnames'
import s from './InfoCard.scss'
import sLay from 'styles/modules/layout.scss'
import { Link } from 'react-router'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

export default props => {
  const {
    className,
    title,
    color,
    titleRight,
    image,
    to,
    toText,
    children,
    loading,
    overlayText,
    allowOverflow,
    ...otherProps
  } = props
  return (
    <div
      className={cn(
        sLay['layout-column'],
        s.card,
        { [s.dark]: color === 'dark', [s.red]: color === 'red', [s.hideOverflow]: !allowOverflow },
        className
      )}
      {...otherProps}
    >
      {title && (
        <div className={cn(s.title, sLay['layout-row'], sLay['layout-align-start-center'])}>
          {image && <img className={s.image} src={image} />}
          {title}
          <div className={sLay.flex} />
          <div>{titleRight}</div>
        </div>
      )}
      <div className={cn(sLay['layout-column'], sLay.flex)} style={{ position: 'relative' }}>
        {children}
        {loading && <LoadingOverlay color={color} />}
      </div>
      {((to && toText) || overlayText) && <div className={s.overlay}>{overlayText}</div>}
      {to && toText && (
        <Link
          to={to}
          className={cn(s.button, sLay['layout-column'], sLay['layout-align-center-center'])}
        >
          {toText}
        </Link>
      )}
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/Cards/InfoCard/InfoCard.jsx